export default defineAppConfig({
  theme: { primary: 'teal' },
  ui: {
    strategy: 'override',
    primary: 'teal',
    select: {
      placeholder: 'text-gray-400 dark:text-gray-500 text-base',
    },
    selectMenu: {
      placeholder: 'text-gray-400 dark:text-gray-500 text-base',
    },
  },
});
